"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.RadioGroupComponent = exports.RadioGroupContext = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _forms = require("@morpheus-ui/forms");

var _ThemeProvider = _interopRequireWildcard(require("./ThemeProvider"));

var RadioGroupContext = (0, _react.createContext)({
  getTheme: function getTheme() {
    return _ThemeProvider.DEFAULT_THEME.Radio.default;
  },
  onChange: function onChange() {}
});
exports.RadioGroupContext = RadioGroupContext;

var RadioGroupComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(RadioGroupComponent, _Component);

  function RadioGroupComponent(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChangeValue", function (value) {
      _this.props.onChange && _this.props.onChange(value);

      if (!_this.props.inForm) {
        _this.setState({
          value: value
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getTheme", function (props) {
      return (0, _ThemeProvider.getTheme)('Radio', props, _this.context);
    });
    _this.state = {
      value: _props.defaultValue
    };
    return _this;
  }

  var _proto = RadioGroupComponent.prototype;

  _proto.getValue = function getValue() {
    var _this$props = this.props,
        inForm = _this$props.inForm,
        defaultValue = _this$props.defaultValue,
        value = _this$props.value,
        fieldValue = _this$props.fieldValue;

    if (inForm) {
      return fieldValue != null ? fieldValue : defaultValue || null;
    }

    if (value != null) {
      return value || defaultValue || null;
    }

    return this.state.value;
  };

  _proto.render = function render() {
    var value = this.getValue();
    return _react.default.createElement(RadioGroupContext.Provider, {
      value: {
        value: value,
        getTheme: this.getTheme,
        onChange: this.onChangeValue
      }
    }, this.props.children);
  };

  return RadioGroupComponent;
}(_react.Component);

exports.RadioGroupComponent = RadioGroupComponent;
(0, _defineProperty2.default)(RadioGroupComponent, "contextType", _ThemeProvider.default);

var _default = (0, _forms.turnIntoField)(RadioGroupComponent);

exports.default = _default;